import Vue from 'vue'
import DJPipeline from './views/DJPipeline.vue'
import router from './router'
import { domain, clientId, audience, useRefreshTokens, cacheLocation } from "../auth_config.json";
import { Auth0Plugin } from "./auth_plugin";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  useRefreshTokens,
  cacheLocation,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});
//Vue.config.devtools = true;
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(DJPipeline)
}).$mount('#app')
